import { useOnline } from '@libs/hooks';
import { ConditionalRender } from '@libs/utils';
import React from 'react';
import { CommonScreen } from './CommonScreen/CommonScreen';
import { WiFiIcon } from './Svg/WiFiIcon';

export const Offline = () => {
    const isOnline = useOnline();

    return (
        <ConditionalRender condition={!isOnline}>
            <CommonScreen
                useIcon={true}
                Icon={WiFiIcon}
                headerText="No internet connection"
                secondaryText={'Check your internet connection and try again'}
                buttonLabel="Try again"
            />
        </ConditionalRender>
    );
};
